<script lang="ts">
  import { getWrapperStyles } from '../helpers/sections-helper';
  import HeroBlurb from './HeroBlurb.svelte';
  import type {
    GlobalProperties,
    UseFormattedProps,
  } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;
  export let settings: GlobalProperties;

  $: ({ backgroundHeroImage } = properties);
</script>

<section class="hero" id={properties?.anchor}>
  <div class="image">
    <img src={backgroundHeroImage} alt="bg-img" />
  </div>
  <div class="wrapper" style={getWrapperStyles()}>
    <HeroBlurb {properties} {settings} narrow />
  </div>
</section>

<style>
  .hero {
    position: relative;
    height: clamp(600px, 70vh, 70vh);
    overflow: hidden;
    background-color: var(--vlt-lp-background, #fff);
  }
  .wrapper {
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 15px;
  }
  .image {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 50%;
  }
  .image:after {
    content: '';
    position: absolute;
    bottom: -10px;
    right: -10px;
    left: -10px;
    height: 100px;
    background-color: var(--vlt-lp-background, #fff);
    transform: rotate(6deg);
    box-sizing: border-box;
    transform-origin: top left;
  }
  .image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: var(--background-position, center);
  }
  @media screen and (max-width: 865px) {
    .hero {
      height: auto;
    }
    .image {
      position: relative;
      top: unset;
      bottom: unset;
      left: unset;
      right: unset;
      height: 300px;
      overflow: hidden;
      margin-bottom: -10px;
    }
  }
  @media screen and (max-width: 767px) {
    .wrapper {
      padding: 0 15px !important;
    }
  }
  @media screen and (max-width: 600px) {
    .image {
      margin-bottom: -40px;
    }
  }
</style>
